import React from 'react';
import { withTranslation } from 'react-i18next';


const InfoBox = (props) => (
    <div className="App-infoBox">
        {props.t('info1')}<a href='https://apps.leg.wa.gov/rcw/default.aspx?cite=42.56 '>{props.t('info2')}</a>{props.t('info3')}<a href='http://www.seattle.gov/tech/initiatives/privacy/about-the-privacy-program'>{props.t('info4')}</a>{props.t('info5')}
    </div>
)

export default withTranslation()(InfoBox);